import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Toaster } from '@/components/ui/Toaster';
import { BreadcrumbsProvider } from '@/contexts/BreadcrumbsContext';
import { useBreadcrumbs } from '@/contexts/BreadcrumbsUtils';

import { Sidebar } from './Sidebar';
import { HeaderBar } from './HeaderBar';
import { MobileSidebar } from './MobileSidebar';
import { navItems } from '../../config/navigation';

const LayoutWithBreadcrumbs = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const { breadcrumbs } = useBreadcrumbs();

  return (
    <div className="min-h-screen bg-[--color-background-app] text-neutral-950">
      <Sidebar navItems={navItems} />
      <MobileSidebar
        open={isMobileSidebarOpen}
        onOpenChange={setIsMobileSidebarOpen}
        navItems={navItems}
      />
      <div className="flex min-h-screen flex-col lg:pl-[260px]">
        <HeaderBar
          onMenuClick={() => setIsMobileSidebarOpen(true)}
          breadcrumbs={breadcrumbs || undefined}
        />
        <main className="flex-1 overflow-y-auto bg-white px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </main>
      </div>
      <Toaster />
    </div>
  );
};

export const MainLayout = () => {
  return (
    <BreadcrumbsProvider>
      <LayoutWithBreadcrumbs />
    </BreadcrumbsProvider>
  );
};
